// ======================================================================
// File Name       : AdaptiveBatchImport
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Button, Col } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import { VALIDATE_TYPE, ROOT_URL } from '../../constants/index';
import CustomButton from '../button/CustomButton';

class AdaptiveBatchImport extends React.Component {
  render() {
    const {
      importAdaptiveMeta,
      exportAdaptiveMeta,
      fileName,
      fileSize,
      disabled,
      csvSamplePath,
    } = this.props;
    const link = csvSamplePath ? ROOT_URL + csvSamplePath : '/top';
    return (
      <div>
        <Col sm={12} className="margin-bottom-10 padding-left-right-clear">
          <h3>一括出力するには、以下のボタンを押してください</h3>
        </Col>
        <Col sm={12} className="margin-top-10 margin-bottom-10">
          <CustomButton
            btnStyle="btn btn-primary btn-96"
            handleClick={exportAdaptiveMeta}
            text="一括出力"
            iconClass="bi bi-download"
          />
        </Col>
        <Col sm={12} className="margin-top-10 margin-bottom-10">
          <a
            role="button"
            href={link}
          >
            <u>サンプルダウンロード</u>
          </a>
        </Col>
        <Col sm={12} className="margin-top-10 padding-left-right-clear">
          <h3>一括編集するためのファイルを指定してください</h3>
        </Col>
        <Col sm={12} className="margin-top-10">
          <Col sm={8} className="padding-left-right-clear">
            <RenderField
              type="batchimport"
              name="uploadFile"
              label="参照"
              validates={[VALIDATE_TYPE.DOCUMENT_SIZE, VALIDATE_TYPE.ACCEPT_FILE]}
              value={fileSize}
              fileName={fileName}
              fileSize={fileSize}
              fieldInput={9}
              fieldButton={3}
              accept={'application/zip,application/x-zip,application/x-zip-compressed'}
              changeFile={this.props.changeFile} // sprint_20230403-UT-001
            />
          </Col>
          <Col sm={4} className="float-end padding-left-right-clear">
            <Button variant="primary" className="btn-96" type="submit" disabled={disabled}>
              一括編集
            </Button>
          </Col>
        </Col>
      </div>
    );
  }
}

export default AdaptiveBatchImport;
